
export default function getPosition (node, scope) {
    var root = scope || document;
    var offsetTop  = node.offsetTop;
    var offsetLeft = node.offsetLeft;
    while (node && node.offsetParent && node.offsetParent != document && node !== root && root !== node.offsetParent ) {
      offsetTop += node.offsetParent.offsetTop;
      offsetLeft += node.offsetParent.offsetLeft;
      node = node.offsetParent;
    }
    return {
      top: offsetTop,
      left: offsetLeft
    };
}
